import { Component } from '@angular/core';
//import { ICellRendererParams } from '@ag-grid-enterprise/all-modules'
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'flagged',
    templateUrl: './flagged.component.html',
    styleUrls: ['./flagged.component.scss'],
    standalone: false
})
export class FlaggedComponent implements ICellRendererAngularComp {
    public _params: ICellRendererParams;
    cell: { row: any, colHeader: string };
    iconToUse: string = 'icon-blocked';
    constructor() {
    }

    agInit(params: ICellRendererParams & { values?:  string }): void {
        this._params = params;
        this.iconToUse =  params.values;
        this.cell = { row: params.value, colHeader: params.colDef.headerName };
    }

    getIcon() {
        return this.iconToUse;
    }

    refresh(params: any): boolean {
        return true;
    }
}
